import { useState, React } from "react";
import { Zoom, Fade } from "react-awesome-reveal";
import dsc from "../media/DSC.webp";
import scr from "../media/SCR.webp";
import gotg from "../media/GymShark_Landing_Page.jpg";
import rfp from "../media/RFP.webp";
import ca from "../media/youtube_mini_hero_Image_github.jpg";
import tcd from "../media/ShopClues_Landing_Page.jpg";
import amazonPrimePage from "../media/amazon-prime-video-homepage.jpg";
import apartmentManager from "../media/apartmentManager.jpg";
import adminDashBoardPage from "../media/admin-dashboard-HomePage.png";
import chatApplication from "../media/Chat-application.png";
import ticketingApplication from "../media/Ticketing-App.png";
import pixelForgeApplication from "../media/PixelForge-Saas.png";
import Container from "react-bootstrap/esm/Container";
import Button from "react-bootstrap/esm/Button";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Card from "react-bootstrap/esm/Card";
import Modal from "react-bootstrap/Modal";

const Experience = ({ darkMode }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const abc = () => {
  //     if (!("ontouchstart" in document.documentElement)) {
  //         document.documentElement.className += " no-touch";
  //         }
  // }

  return (
    <div data-theme={darkMode ? "dark" : "light"}>
      <br />
      <Fade>
        <Container>
          <br />
          <h2 className="lead" align="center">
            <b>- Projects -</b>
          </h2>
          <br />
          <Zoom>
            <Row>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={pixelForgeApplication}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              PixelForge SaaS App
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                Build an AI image SaaS platform that excels in
                                image processing, integrates a secure payment
                                infrastructure and supports multiple AI
                                features.
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>

                          <p align="left">
                            Secure user access with registration, login, and
                            route protection.
                            <br />
                            <br />
                            Multiple AI features, including image restoration,
                            recoloring, object removal, generative filling, and
                            background removal
                            <br />
                            <br />
                            Credit Purchase: Securely buy credits via Stripe for
                            uninterrupted use
                          </p>

                          <h6>
                            Tech Stack: NextJS | TypeScript | Clerk | Cloudinary
                            | Stripe | Shadcn | MongoDb
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://my-next-saas-app.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/my-next-saas-app"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={ticketingApplication}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Ticketing App
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                Developed a CRUD app using NextJS tech-stack for
                                the developer team to raise tickets for
                                application issues
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>

                          <p align="left">
                            Can add, remove, update tickets from the application
                            <br />
                            <br />
                            The App Router simplifies the management of routes
                            within our application, making it easier to handle
                            navigation between different pages.
                            <br />
                            <br />
                            Utilized MongoDB database for efficient data storage
                            and management.
                          </p>

                          <h6>
                            Tech Stack: NextJS | Tailwind CSS | TypeScript |
                            MongoDb | RESTful APIs
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://ticket-app-opal.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/Ticket-app"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={chatApplication}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Chat Application
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                Build a Chat application with real-time chat
                                feature using Socket.io including One vs One
                                chat and Group Chat .
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>

                          <p align="left">
                            Can add,remove user from existing group chat and
                            change name of group chat
                            <br />
                            <br />
                            Providing real-time chat notification and latest
                            message functionality.
                            <br />
                            Authentication of user using JSON web-token
                          </p>

                          <h6>
                            Tech Stack: React | Socket.io | Redux-toolkit |
                            Typescript | MUI
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://chat-app-frontend-task.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/Chat-app-frontend-task"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={adminDashBoardPage}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Admin Dashboard
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                Developed an Admin Dashboard that provides
                                comprehensive data visualization.
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>

                          <p align="left">
                            Implemented toggle theme functionality to switch
                            between light and dark modes.
                            <br />
                            <br />
                            Implemented a user-friendly Data Grid component with
                            filtering and exporting functionality to display
                            data in a structured and interactive tabular format.
                          </p>

                          <h6>
                            Tech Stack: React | Redux-toolkit | Typescript | MUI
                            | React Hook Form | Nivo Chart
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://my-admin-dashboard-ts.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/Admin-Dashboard-TS"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>

              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={apartmentManager}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Appartment Manager
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                {" "}
                                Apartment Manager is a website which show
                                details of the apartment flats and the details
                                of residents living in each flat
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>

                          <p align="left">
                            Implementation of Redux for state management <br />
                            Authentication required to update data
                            <br />
                            {/* Displayed data in tabular format to show flat data <br /> */}
                            A flat details page to show the resident details of
                            that flat <br />
                            Functionality to add flat , add & remove resident
                            from flat <br />
                            Pagination and Sorting Functionality
                          </p>

                          <h6>
                            Tech Stack: React | Redux | Redux-Saga | Bootstrap |
                            MongoDb | ExpressJs | NodeJs{" "}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://apartment-manager-theta.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/APARTMENT-MANAGER"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>

              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner">
                        <div className="flip-card-front">
                          <Card.Img
                            variant="top"
                            src={amazonPrimePage}
                            alt="Rooted - Portal for farmers"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Amazon Prime Video Clone
                            </Card.Title>
                            <Card.Text>
                              <p align="left">
                                Build A Clone of Amazon Prime Video Website
                                designed for streaming movies and tv-shows
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          {/* <p>User-friendly and clean basic scripted website */}
                          {/* <br/>Tech Stack - HTML, CSS, JavaScript */}
                          {/* </p> */}
                          <h3>Features</h3>
                          <p align="left">
                            Register and Login functionality
                            <br />
                            Implemented State Management using Redux
                            <br />
                            Home Page containing different Movies and Tv-show
                            fetch using Omdb Api
                            <br />
                          </p>
                          <h6 align="left">
                            Tech Stack: React | Redux | CSS | MongoDb |
                            ExpressJs | NodeJs
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://amazon-prime-video-clone-theta.vercel.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/Amazon-Prime-Video-Clone"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner">
                        <div className="flip-card-front">
                          <Card.Img
                            variant="top"
                            src={gotg}
                            alt="InternExperience"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Gymshark Clone
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">During this internship, I am building a web app to help people with their public speaking ability</p> */}
                              <p align="left">
                                A web application to shop for gym accessories.
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>
                          <p align="left">
                            Add to Cart functionality
                            <br />
                            Dynamic Cart page
                            <br />
                            Promocode functionality on Payment page
                            <br />
                            Search functionality
                            <br />
                          </p>
                          <h6>
                            Tech Stack: HTML | CSS | Javascript | MongoDb |
                            Express
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    {/* <Modal show={show} onHide={handleClose} className="modal">
                                            <Modal.Body>Heya! The project is in development mode, you can visit the repository and have a look. Feel free to contribute!</Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="outline-dark" onClick={handleClose}>
                                                    Close
                                                </Button>
                                                <a href="https://github.com/Tejaswi-Chaudhari/Gift-of-the-Gab" target="_blank" rel="noreferrer noopener">
                                                    <Button variant="outline-dark">View Github Repo</Button>
                                                </a>
                                            </Modal.Footer>
                                        </Modal> */}
                    <a
                      href="https://aniket-pilankar.github.io/Gymshark_FRONTEND_Unit4/index.html"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        onClick={handleShow}
                        className="sbtn"
                      >
                        View Project
                      </Button>
                    </a>

                    <a
                      href="https://github.com/Aniket-Pilankar/Gymshark_FRONTEND_Unit4"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner ">
                        <div className="flip-card-front " id="changeABC">
                          <Card.Img
                            variant="top"
                            src={tcd}
                            alt="Toxic Comment Detector"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">
                              Shopclues Clone
                            </Card.Title>
                            <Card.Text>
                              {/* <p align="center">A Chrome Extension which can detect whether the input text is Positive or Negative.</p> */}
                              <p align="left">
                                An e-commerce website to shop for lifestyle
                                items like clothes, footwear, accessories, etc.
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          {/* <p>Implemented Linear Regression Algorithm of Scikit-Learn library on well-preprocessed dataset of Kaggle.
                                                        <br/>Hosted the Machine Learning Model on Heroku and Mia, integrated the hosted model in a Chrome Extension.
                                                        <br/>Achieved ROC AUC Score of 93.5%
                                                    </p> */}
                          {/* <ul>
                                                        <li>Add to cart functionality and Cart page</li>
                                                        <li>Sorting and Filter feature based on price and discount</li>
                                                        <li>Payment Gateway</li>
                                                    </ul> */}
                          <h3>Features</h3>
                          <p align="left">
                            Add to cart functionality and Cart page. Sorting and
                            Filter feature based on price and discount.
                            <br /> Payment Gateway <br />{" "}
                          </p>
                          <h6 align="left">
                            Tech Stack: HTML | CSS | Javascript
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://aniket-pilankar-shopclues-clone.netlify.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn mx-10"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/bishal-Samanta/Project-Shopclues"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>
              <Col lg={4} sm={12}>
                <Card
                  align="center"
                  className="exp"
                  data-theme={darkMode ? "dark" : "light"}
                >
                  <br />
                  <center>
                    <div class="flip-card">
                      <div class="flip-card-inner">
                        <div className="flip-card-front">
                          <Card.Img
                            variant="top"
                            src={ca}
                            alt="CharitAble"
                            height="169px"
                            width="300px"
                          />
                          <Card.Body>
                            <Card.Title align="center">YouTube Mini</Card.Title>
                            <Card.Text>
                              <p align="center">
                                A youTube mini application to search and play
                                youtube videos
                              </p>
                            </Card.Text>
                          </Card.Body>
                        </div>
                        <div className="flip-card-back">
                          <h3>Features</h3>
                          <p align="left">
                            Search for any vidoes
                            <br />
                            Get relevant similar video of the video which you
                            clicked
                          </p>
                          <h6>
                            Tech Stack: HTML | CSS | Javascript | YouTube Api
                          </h6>
                        </div>
                      </div>
                    </div>
                  </center>
                  <br />
                  <div>
                    <a
                      href="https://aniketpilankar-youtube-mini.netlify.app/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Project
                      </Button>
                    </a>
                    <a
                      href="https://github.com/Aniket-Pilankar/Youtube-mini"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Button
                        variant={darkMode ? "outline-light" : "outline-dark"}
                        className="sbtn"
                      >
                        View Github Repo
                      </Button>
                    </a>
                  </div>
                  <br />
                </Card>
              </Col>

              {/* <Col lg={4} sm={12}>
                                <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                                    <br />
                                    <center>
                                        <div class="flip-card">
                                            <div class="flip-card-inner " >
                                                <div className="flip-card-front " id='changeABC' >
                                                    <Card.Img variant="top" src={tcd} alt="Toxic Comment Detector" height="169px" width="300px" />
                                                    <Card.Body>
                                                        <Card.Title align="center">Shopclues Clone</Card.Title>
                                                        <Card.Text>
                                                            
                                                            <p align="center">An e-commerce website to shop for lifestyle items like clothes, footwear, accessories, etc.</p>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </div>
                                                <div className="flip-card-back">
                                                    <h3>Features</h3>
                                                    <p>Add to cart functionality and Cart page. Sorting and Filter feature based on price and discount.<br /> Payment Gateway <br /> </p>
                                                    <h6>Tech Stack: HTML | CSS | Javascript</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <br />
                                    <div >
                                        <a href="https://aniket-pilankar-shopclues-clone.netlify.app/" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn mx-10">View Project</Button>
                                        </a>
                                        <a href="https://github.com/bishal-Samanta/Project-Shopclues" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                                        </a>
                                    </div>
                                    <br />
                                </Card>
                            </Col> */}
              {/* <Col lg={4} sm={12}>
                                <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                                    <br />
                                    <center>
                                        <div class="flip-card">
                                            <div class="flip-card-inner">
                                                <div className="flip-card-front">
                                                    <Card.Img variant="top" src={gotg} alt="InternExperience" height="169px" width="300px" />
                                                    <Card.Body>
                                                        <Card.Title align="center">Gymshark Clone</Card.Title>
                                                        <Card.Text>
                                                            
                                                            <p align="center">A web application to shop for gym accessories.</p>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </div>
                                                <div className="flip-card-back">
                                                    <h3>Features</h3>
                                                    <p>Add to Cart functionality
                                                        <br />Dynamic Cart page
                                                        <br />Promocode functionality on Payment page
                                                        <br />Search functionality
                                                        <br />
                                                    </p>
                                                    <h6>Tech Stack: HTML | CSS | Javascript | MongoDb | Express</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <br />
                                    <div>
                                        <Modal show={show} onHide={handleClose} className="modal">
                                            <Modal.Body>Heya! The project is in development mode, you can visit the repository and have a look. Feel free to contribute!</Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="outline-dark" onClick={handleClose}>
                                                    Close
                                                </Button>
                                                <a href="https://github.com/Tejaswi-Chaudhari/Gift-of-the-Gab" target="_blank" rel="noreferrer noopener">
                                                    <Button variant="outline-dark">View Github Repo</Button>
                                                </a>
                                            </Modal.Footer>
                                        </Modal>
                                        <a href="https://aniket-pilankar.github.io/Gymshark_FRONTEND_Unit4/index.html" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} onClick={handleShow} className="sbtn">View Project</Button>
                                        </a>

                                        <a href="https://github.com/Aniket-Pilankar/Gymshark_FRONTEND_Unit4" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                                        </a>
                                    </div>
                                    <br />
                                </Card>
                            </Col> */}
            </Row>
          </Zoom>
          <br />
          {/* <Col lg={4} sm={12}>
                                <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                                    <br />
                                    <center>
                                        <div class="flip-card">
                                            <div class="flip-card-inner">
                                                <div className="flip-card-front">
                                                    <Card.Img variant="top" src={amazonPrimePage} alt="Rooted - Portal for farmers" height="169px" width="300px" />
                                                    <Card.Body>
                                                        <Card.Title align="center">Amazon Prime Video Clone</Card.Title>
                                                        <Card.Text>
                                                            <p align="center">Build A Clone of Amazon Prime Video Website designed for streaming movies and tv-shows</p>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </div>
                                                <div className="flip-card-back">
                                                    <h3>Features</h3>
                                                    <p>Register and Login functionality
                                                        <br />Implemented State Management using Redux
                                                        <br />Home Page containing different Movies and Tv-show fetch using Omdb Api
                                                        <br />
                                                    </p>
                                                    <h6>Tech Stack: React | Redux | CSS | MongoDb | ExpressJs | NodeJs</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <br />
                                    <div>
                                        <a href="https://amazon-prime-video-clone-theta.vercel.app/" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Project</Button>
                                        </a>
                                        <a href="https://github.com/Aniket-Pilankar/Amazon-Prime-Video-Clone" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                                        </a>
                                    </div>
                                    <br />
                                </Card>
                            </Col> */}
          {/* <Col lg={4} sm={12}>
                                <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                                    <br/>
                                    <center>
                                        <div class="flip-card">
                                            <div class="flip-card-inner">
                                                <div className="flip-card-front">
                                                    <Card.Img variant="top" src={dsc} alt="Google Developer Student Clubs" height="169px" width="300px"/>
                                                    <Card.Body>
                                                        <Card.Title align="center">Google Developer Student Clubs</Card.Title>
                                                        <Card.Text>
                                                            <p align="center">Current GDSC Lead and Former-Core Team Member of GDSC UMIT</p>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </div>
                                                <div className="flip-card-back">
                                                    <p>Created and managing a team of 18 people and a community of 300+ members
                                                        <br/>Organized Study Jams, Hackathons and Webinars.
                                                        <br/>Hosted events of Google Cloud and Machine Learning.
                                                        <br/>Guided students in Google Cloud and Android Development Study Jams
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <br/>
                                    <div>
                                        <a href="https://dscumit.netlify.app/" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Website</Button>
                                        </a>
                                        <a href="https://www.instagram.com/dsc__umit/" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">Instagram Handle</Button>
                                        </a>
                                    </div>
                                    <br/>
                                </Card>
                            </Col>
                            <Col lg={4} sm={12}>
                                <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                                    <br/>
                                    <center>
                                        <div class="flip-card">
                                            <div class="flip-card-inner">
                                                <div className="flip-card-front">
                                                    <Card.Img variant="top" src={scr} alt="Student Council" height="169px" width="300px"/>
                                                    <Card.Body>
                                                        <Card.Title align="center">Student Council</Card.Title>
                                                        <Card.Text>
                                                            <p align="center">Representative of Department of Computer Science and Technology, UMIT</p>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </div>
                                                <div className="flip-card-back">
                                                    <p>Managed and helped students in their curriculum and other difficulties.
                                                        <br/>Co-organized annual fest 'Arcane Illusions'.
                                                        <br/>Coordinated between faculties and students about studies and other activities.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <br/>
                                    <div>
                                        <a href="https://www.instagram.com/umit_sc/" target="_blank" rel="noreferrer noopener">
                                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">Instagram Handle</Button>
                                        </a>
                                    </div>
                                    <br/>
                                </Card>
                            </Col> */}
        </Container>
      </Fade>
      <br />
      <hr />
      <br />
    </div>
  );
};

export default Experience;
